import { render, staticRenderFns } from "./charteredSetting.vue?vue&type=template&id=51aade8d"
import script from "./charteredSetting.vue?vue&type=script&lang=js"
export * from "./charteredSetting.vue?vue&type=script&lang=js"
import style0 from "./charteredSetting.vue?vue&type=style&index=0&id=51aade8d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports